// NOTE: Added by request of inspire team. (https://semboteam.slack.com/archives/C04JKSBKXU3/p1737021792814319)
// Adds compatibility with hard cached pages using old SDK version until cache is flushed.

import { LocalStorageService } from '@libs/utils';

const localStorageService = new LocalStorageService();

// Should be safe to remove by 2026.
export function migrateOldSdkStableIdToNewSdk(): void {
  const OLD_KEY = 'STATSIG_LOCAL_STORAGE_STABLE_ID';
  const NEW_KEY = 'statsig.stable_id.3206961030';

  try {
    const oldKeyStableId = localStorageService.readRawItem(OLD_KEY);
    const newKeyStableId = localStorageService.readRawItem(NEW_KEY);

    if (oldKeyStableId && !newKeyStableId) {
      localStorageService.writeItem(NEW_KEY, oldKeyStableId);
    }
  } catch {
    // localStorage not available, not a problem
  }
}
